import type {
  PostDocumentQueueResumeRequestType,
  PostDocumentQueueResumeResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentsResumeQueue = async (
  params: PostDocumentQueueResumeRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue/resume`;
  const response =
    await apiAuthClient.post<PostDocumentQueueResumeResponseType>(url);

  return response.data;
};
